// 用户状态模块
const state = {
  // 用户信息
  userInfo: null,
  // 认证token
  token: null,
  // 是否登录
  isLoggedIn: false
}

const mutations = {
  // 设置用户信息
  SET_USER_INFO(state, userInfo) {
    state.userInfo = { 
      ...userInfo, 
      avatar: userInfo.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },
  // 更新用户头像
  UPDATE_AVATAR(state, avatarUrl) {
    if (state.userInfo) {
      state.userInfo.avatar = avatarUrl
      // 同步更新localStorage
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    }
  },
  // 设置token
  SET_TOKEN(state, token) {
    state.token = token
  },
  // 设置登录状态
  SET_LOGGED_IN(state, status) {
    state.isLoggedIn = status
  },
  // 清空用户信息（退出登录）
  CLEAR_USER(state) {
    state.userInfo = null
    state.token = null
    state.isLoggedIn = false
  }
}

const actions = {
  // 登录操作
  login({ commit }, { userInfo, token }) {
    commit('SET_USER_INFO', userInfo)
    commit('SET_TOKEN', token)
    commit('SET_LOGGED_IN', true)
    // 存储到localStorage
    localStorage.setItem('token', token)
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  // 退出登录
  logout({ commit }) {
    commit('CLEAR_USER')
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  },
  // 从localStorage恢复登录状态
  restoreLogin({ commit }) {
    const token = localStorage.getItem('token')
    const userInfoStr = localStorage.getItem('userInfo')
    if (token && userInfoStr) {
      try {
        const userInfo = JSON.parse(userInfoStr)
        commit('SET_USER_INFO', userInfo)
        commit('SET_TOKEN', token)
        commit('SET_LOGGED_IN', true)
      } catch (e) {
        commit('CLEAR_USER')
      }
    }
  }
}

const getters = {
  // 获取用户ID
  userId: state => state.userInfo?.user_id,
  // 获取用户名
  userName: state => state.userInfo?.username,
  // 获取用户头像
  avatar: state => state.userInfo?.avatar
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
